import { LocationModel } from "./location.model";

export class LocationGroup {
    id: string;
    name: string;
    locations?: LocationModel[];
}